// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"dfe87231","217":"ee710479","567":"404edd99"}[chunkId] + ".chunk.css";
};